export default "__VITE_ASSET__uJP5JAV1__"